import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=1246b7c7&scoped=true"
import script from "./AuditLog.vue?vue&type=script&lang=js"
export * from "./AuditLog.vue?vue&type=script&lang=js"
import style0 from "./AuditLog.vue?vue&type=style&index=0&id=1246b7c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1246b7c7",
  null
  
)

export default component.exports